module.exports = __webpack_public_path__ + "static/img/banner_pressCenter.756f45b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/english/banner_pressCenter.png
// module id = 882f
// module chunks = 15